import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FormControlLabel } from "@mui/material";
import {
  Button,
  Col,
  Form,
  Row,
  Stack,
  Container,
  Card,
} from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Formik } from "formik";
import { nameBasedRoutes } from "../../router/public";
import { nameBasedProtectedRoutes } from "../../router/protected";
import FormHelperText from "@mui/material/FormHelperText";
import InputText from "../../components/common/InputText";
import InputSelect from "../../components/common/InputSelect";
import InputSelectMultiple from "../../components/common/InputSelectMultiple";
import InputTextArea from "../../components/common/TextArea";
import InputDatePicker from "../../components/common/InputDatePicker";
import storage from "../../helpers/storage";
import { getUserDetails, getMachineList } from "../../services/userService";
import {
  checkMachineExists,
  getSrDetails,
  inspectionRequest,
} from "../../services/inspectionRequest";
import { getStateList } from "../../services/authService";
import Loader from "../../components/common/Loader";
import {
  InspectionRequestSchema,
  AddMachineSchema,
} from "../../validations/InspectionRequest";
import plusIcon from "../../assets/images/plus-solid.svg";
import PlusBlue from "../../assets/images/plus-blue.svg";
import DeleteIcon from "../../assets/images/Delete-icon.svg";
import GooglePinIcon from "../../assets/images/google-pin-icon.svg";
import { withScriptjs, withGoogleMap, Marker } from "react-google-maps";
import DatePicker from "react-datepicker";
import Modal from "react-bootstrap/Modal";
import "react-datepicker/dist/react-datepicker.css";
import DraggableMarkerMap from "./DraggableMarkerMap";
import MatDatePicker from "../../components/common/MatDatePicker";
import moment from "moment";
import { toast } from "react-toastify";
import { MESSAGES } from "../../constants/messages";
import InputSelectMultipleAutocomplete from "components/common/InputSelectMultipleAutocomplete";

let center = {
  lat: 40.73061,
  lng: -73.935242,
};

export const InspectionRequest = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [googleFields, setGoogleFields] = useState(true);
  const ref = useRef<any>();
  const buttonRef = useRef<any>(null);
  const [jobState, setJobState] = useState("");

  const [show, setShow] = useState(false);
  const handleModalClose = () => setShow(false);
  const [formFieldValue, setFormFieldValue] = useState<any>([]);
  const [selectMachines, setSelectMachines] = useState<any>([]);
  let setFormFieldValues: any[];
  const [noMachine, setNoMachine] = useState<number>();
  const handleShow = (setFieldValue: any) => {
    setFormFieldValues = setFieldValue;
    setNoMachine(5);
    setShow(true);
    setFormFieldValue(setFieldValue);
  };
  let { id } = useParams();
  let initialValues = {
    project_name: "",
    no_machine: "",
    job_contact: "",
    company_name: "",
    po_no: "",
    ordered_by: "",
    inspection_datetime: null,
    machine_inspect: [],
    job_location: "",
    job_location_address: "",
    job_location_city: "",
    job_location_state: "",
    job_location_zip_code: "",
    job_location_comment: "",

    decal_name: "",
    decal_email: "",
    decal_address: "",
    decal_city: "",
    decal_state: "",
    decal_zip_code: "",

    Status: false,
  };
  const [initialVal, setInitialVal] = useState<any>(initialValues);

  const initialValuesMachine = {
    device_id: "",
    make: "",
    model_number: "",
    serial_number: "",
    inspection_type: "",
  };
  const [states, setStates] = useState([]);
  const [machines, setMachines] = useState<any>([]);
  const [machineList, setMachineList] = useState<any>([]);
  const [decalContact, setDecalContact] = useState<any>([]);

  const [userData, setuserData] = useState<any>({
    id: "",
    first_name: "",
    last_name: "",
    email: "",
    createdAt: "",
    updatedAt: "",
    role: "",
    decalContact: {
      name: null,
      email: "",
      cell_number: "",
      address: "",
      state_id: null,
      city: "",
      zip_code: "",
      state: {
        title: "",
        code: "",
      },
    },
  });
  const userInformation: any = storage.getData("user-info");
  const [machineData, setMachineData] = useState<any>([]);
  const [mainFormActions, setMainFormActions] = useState<any>([]);

  const userId = userInformation.id;
  let isMachine = false;
  let isUserData = false;
  let isStates = false;
  const [hideShowMachineDropdown, setHideShowMachineDropdown] = useState(true);
  const [hideShowNoMachine, setHideShowNoMachine] = useState(true);
  const [inspectionTypeOptions, setInspectionTypeOptions] = useState<any>([]);

  useEffect(() => {
    if (storage.getToken() != null) {
      getUserData();
    }
  }, []);

  const getMachineListData = async () => {
    await getMachineList({ userId })
      .then((response) => {
        setMachines(response.data);
        const newData = machines.map((obj: any) => ({
          key: obj.id,
          value:
            obj.make +
            "(" +
            obj.device_id +
            "/" +
            obj.model_number +
            "/" +
            obj.serial_number +
            ")",
        }));

        setMachineList(newData);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  let newData: any[] = [];
  const getUserData = async () => {
    await getMachineList({ userId })
      .then(async (response) => {
        setMachines(response.data);

        const newData = await Promise.all(
          response.data.map(async (obj: any) => {
            const manipulatedValue = await manipulateValue(obj);
            return { key: obj.id, value: manipulatedValue };
          })
        );

        const uniqueArray = await Promise.all(
          Array.from(new Set(newData.map((a) => a.value.toLowerCase()))).map(
            (value) => {
              return newData.find(
                (a) => a.value.toLowerCase() === value.toLowerCase()
              );
            }
          )
        );

setMachineList(uniqueArray);

        await getUserDetails({ userId })
          .then((response) => {
            setuserData(response.data);
            setDecalContact(response.data.decalContact);
            if (response.data.parent_id)
              setDecalContact(response.data.parent.decalContact);
            setInspectionTypeOptions(response?.inspectionType);
            getStateList()
              .then((response) => {
                setStates(response?.data);
                getSrInspectionData();
              })
              .catch((error) => {
                toast.error(error?.response?.data?.message);
              });
          })
          .catch((error) => {
            setLoading(false);
          });
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  // Get Service Request data by inspection id
  const getSrInspectionData = async () => {
    if (id) {
      getSrDetails({ id })
        .then(async (response) => {
          const machines = response?.data?.Inspection_machines;
          const inspection = response?.data;

          const newData = await Promise.all(
            machines.map(async (obj: any) => {
              let inspectionType = obj?.inspection_type;
              if (obj.inspection_type != "" && obj.inspection_type != null) {
                const findValue = response?.inspectionType.find(
                  (item: any) => item.key === obj.inspection_type
                );
                if (findValue) {
                  inspectionType = findValue.value;
                }
              }

              return {
                id: obj?.id,
                machine_id: obj?.machine_id,
                device_id: obj?.device_id,
                make: obj?.make,
                model_number: obj?.model_number,
                serial_number: obj?.serial_number,
                inspection_type: obj?.inspection_type,
                inspection_type_show: inspectionType,
              };
            })
          );

          const oldInspectionData = {
            project_name: inspection?.title,
            no_machine: inspection?.no_machines,
            job_contact: inspection?.job_contact_no,
            po_no: inspection?.po_no,
            ordered_by: inspection?.ordered_by,
            job_location: inspection?.address,
            job_location_address: inspection?.address,
            job_location_city: inspection?.city,
            job_location_state: inspection?.state_id,
            job_location_zip_code: inspection?.zipcode,
            job_location_comment: inspection?.notes,
          };
          center = inspection?.address_latlng
            ? JSON.parse(inspection?.address_latlng)
            : center;
          setInitialVal(oldInspectionData);

          setMachineData(newData);

          // setInspectionData(response?.data);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  const manipulateValue = (obj: any) => {
    return (
      (obj.make ? obj.make : "-") +
      "(" +
      (obj.device_id ? obj.device_id : "-") +
      "/" +
      (obj.model_number ? obj.model_number : "-") +
      "/" +
      (obj.serial_number ? obj.serial_number : "-") +
      ")"
    );
  };

  const updateLoader = () => {
    if (isUserData && isMachine && isStates) {
      setLoading(false);
    }
  };

  const addSelectedMachine = async (
    ids: any,
    setFieldValue: any,
    no_machine: any
  ) => {
    selectMachines.forEach((val: any) => {
      let machineL = machineList.filter((item: any) => item.value === val.value);
      if (machineL) {
        let id = machineL[0].key;
        let checkAlreadyAdded = machineData.filter(
          (item: any) => item.id === id
        );

        if (checkAlreadyAdded.length > 0) {
          toast.error("Machine " + val?.value + " Already added.");
          return false;
        } else {
          if (id) {
            let machine = machines.filter((item: any) => item.id === id);
            let checkAlreadyAdded = machineData.filter(
              (item: any) =>
                /* item.device_id.toLowerCase() ===
                  machine[0].device_id.toLowerCase() && */
                (item.make ?? "").trim().toLowerCase() === (machine[0].make ?? "").trim().toLowerCase() &&
                (item.model_number ?? "").trim().toLowerCase() ===
                  (machine[0].model_number ?? "").trim().toLowerCase() &&
                (item.serial_number ?? "").trim().toLowerCase() ===
                  (machine[0].serial_number ?? "").trim().toLowerCase()
            );
            if (checkAlreadyAdded.length > 0) {
              toast.error("Machine " + val.value + " Already added.");
              return false;
            } else {
              let inspectionType = inspectionTypeOptions.find(
                (type: any) => type.key === machine[0].inspection_type
              );
              let newData = {
                id: machine[0].id,
                machine_id: machine[0]?.machine_id,
                device_id: machine[0].device_id,
                make: machine[0].make,
                model_number: machine[0].model_number,
                serial_number: machine[0].serial_number,
                inspection_type: machine[0].inspection_type,
                inspection_type_show: inspectionType?.value,
              };

              setMachineData((prev: any) => [...prev, newData]);
              buttonRef.current.click();
            }
          }
        }
      }
    });
  };

  const addData = () => {
    const newData = {
      id: 4,
      device_id: "new data",
      make: 235,
      model_number: 253,
      serial_number: 255,
      inspection_type: 256,
    };
    setMachineData((prev: any) => [...prev, newData]);
  };

  const deleteMachine = (idx: any) => {
    // let newData = machineData.filter((item:any) => item.id !== id);
    // setMachineData(newData);

    let newData = [...machineData];
    newData.splice(idx, 1);
    setMachineData(newData);
  };
  const [inspectionDatetime, setInspectionDatetime] = useState<any>(null);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const handleSubmit = async (values: any, actions: any) => {
    setDisableSubmit(true);
    if (inspectionDatetime !== null) {
      let inspectionDate = moment(inspectionDatetime).format("YYYY/MM/DD");
      let inspectionTime = moment(inspectionDatetime).format("H:mm:ss");
      const inspectionPreferredDateTime =
        moment(inspectionDatetime).format("YYYY-MM-DD H:mm:ss");

      const newData = await Promise.all(
        machineData.map(async (obj: any) => {
          const { inspection_type_show, ...rest } = obj;
          return rest;
        })
      );

      let formData = {
        inspection_date: inspectionDate,
        inspection_time: inspectionTime,
        job_contact: values.job_contact,
        inspection_date_time: inspectionPreferredDateTime,
        job_location_address: values.job_location_address,
        job_location_city: values.job_location_city,
        job_location_comment: values.job_location_comment,
        job_location_state: values.job_location_state,
        job_location_zip_code: values.job_location_zip_code,
        job_location_latlng: JSON.stringify(markerPosition),
        no_machine: newData.length > values.no_machine ? newData.length :values.no_machine ,
        ordered_by: values.ordered_by,
        po_no: values.po_no,
        project_name: values.project_name,
        machineData: newData,
        user_id: userId,
      };

      inspectionRequest(formData)
        .then((response) => {
          setLoading(false);
          toast.success(response?.data?.message);
          setTimeout(() => {
            navigate(nameBasedProtectedRoutes.dashborad.path);
          }, 1000);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error?.response?.data?.message);
          setDisableSubmit(false);
        });
    } else {
      toast.error(MESSAGES.requiredDateTime);
      setDisableSubmit(false);
    }
  };

  const addMachineSubmitForm = async (values: any, actions: any) => {
    let inspectionType = inspectionTypeOptions.find(
      (type: any) => type.key === values.inspection_type
    );
    const newData = {
      id: "",
      device_id: values.device_id,
      make: values.make,
      model_number: values.model_number,
      serial_number: values.serial_number,
      inspection_type: values.inspection_type,
      inspection_type_show: inspectionType?.value,
    };
    // Check machine is already inprogress or used by another user
    const { id, inspection_type_show, ...machineExists } = newData;
    checkMachineExists(machineExists)
      .then((response) => {
        if (response?.machineExist) {
          toast.error(response?.message);
        } else {
          let checkAlreadyAdded = machineData.filter((item: any) => {
            // Handle null values for device_id
            const itemDeviceId = item.device_id ? item.device_id.toLowerCase() : null;
            const valuesDeviceId = values.device_id ? values.device_id.toLowerCase() : null;
          
            return (
              /* itemDeviceId === valuesDeviceId && */
              (item.make ?? "").trim().toLowerCase() === (values.make ?? "").trim().toLowerCase() &&
              (item.model_number ?? "").trim().toLowerCase() === (values.model_number ?? "").trim().toLowerCase() &&
              (item.serial_number ?? "").trim().toLowerCase() === (values.serial_number ?? "").trim().toLowerCase()
            );
          });
          if (checkAlreadyAdded.length > 0) {
            toast.error("This Machine is Already added.");
            return false;
          } else {
            console.log("check")
            setMachineData((prev: any) => [...prev, newData]);
            handleModalClose();
            buttonRef.current.click();
          }
        }
        
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [googleAddress, setGoogleAddress] = useState<any>(null);
  const [markerPosition, setMarkerPosition] = useState<any>(null);
  const [stateGoogle, setStateGoogle] = useState<any>(null);
  const handleReverse = (googleAddress: any, markerPosition: any) => {
    setGoogleAddress(googleAddress);
    setMarkerPosition(markerPosition);
    let stateGoogle: any = states.filter((item: any) => {
      return item.value.toLowerCase() == googleAddress.state.toLowerCase();
    });
    if (stateGoogle.length > 0) {
      setStateGoogle(stateGoogle[0].key);
    } else {
      setStateGoogle("");
    }
  };

  const assignAddress = async (values: any, setFieldValue: any) => {

    googleAddress.address
      ? setFieldValue("job_location_address", googleAddress.streetAddress)
      : setFieldValue("job_location_address", null);
    googleAddress.city
      ? setFieldValue("job_location_city", googleAddress.city)
      : setFieldValue("job_location_city", null);
    stateGoogle
      ? setFieldValue("job_location_state", stateGoogle)
      : setFieldValue("job_location_state", null);
    googleAddress.zipcode
      ? setFieldValue("job_location_zip_code", googleAddress.zipcode)
      : setFieldValue("job_location_zip_code", null);

    hideShowGoogleFields(false);
    await Promise.resolve();
    hideShowGoogleFields(true);
  };

  const hideShowGoogleFields = (status: any) => {
    setGoogleFields(status);
  };

  useEffect(() => {
    buttonRef?.current?.click();
  }, [machineData]);

  const updateNoMachine = async (values: any, setFieldValue: any) => {
    const totalMachine = machineData.length;
    const oldValue = !isNaN(values.no_machine) ? values.no_machine : 0;
    if (oldValue < totalMachine) {
      setFieldValue("no_machine", totalMachine);
      setHideShowNoMachine(false);
      await Promise.resolve();
      setHideShowNoMachine(true);
    }
  };

  return (
    <section className="profile-main pt-4 pb-4 dashboard-content">
      <Container className="">
        <Row>
          <Col md={12} lg={12}>
            <Breadcrumb className="border-0 shadow-none mb-0">
              <Breadcrumb.Item
                className="fs-15 fw-semibold text-link"
                href="Javascript:void(0)"
                onClick={() =>
                  navigate(nameBasedProtectedRoutes.dashborad.path)
                }
              >
                Dashboard
              </Breadcrumb.Item>

              <Breadcrumb.Item active className="fs-15 fw-semibold text-gray">
                Request an Inspection
              </Breadcrumb.Item>
            </Breadcrumb>
            <h1 className="fs-30 fw-bold mb-3 mt-2">Request an Inspection</h1>
          </Col>
        </Row>

        {/* Content */}
        <div className="">
          <div className="">
            {!loading ? (
              <Formik
                validationSchema={InspectionRequestSchema}
                enableReinitialize={true}
                initialValues={initialVal}
                onSubmit={handleSubmit}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  errors,
                  touched,
                  setFieldValue,
                  setFieldError,
                  setValues,
                }) => (
                  <Form className="pe-xl-3" noValidate onSubmit={handleSubmit}>
                    <button
                      onClick={() => updateNoMachine(values, setFieldValue)}
                      type="button"
                      ref={buttonRef}
                      className="d-none"
                    >
                      Update Number of Machines
                    </button>
                    <Row>
                      <Col md={12} lg={12}>
                        <Card className="border-0 mb-3">
                          <Card.Body className="br-10 p-4">
                            <div className="col-xl-10">
                              <Row>
                                <Col md="12">
                                  <h2 className="fs-20 fw-bold ls-2 border-left-6 mb-4 text-uppercase">
                                    Inspection Details
                                  </h2>
                                </Col>
                                <Col md="4">
                                  <InputText
                                    controlId="project_name"
                                    label="Project Name"
                                    placeholder="Project Name"
                                    touched={touched.project_name}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.project_name}
                                    value={values.project_name}
                                    autofocus
                                  />
                                </Col>
                                <Col md="4">
                                  {hideShowNoMachine && (
                                    <InputText
                                      controlId="no_machine"
                                      label="No. of Machines to be Inspected"
                                      placeholder="No. of Machines to be Inspected"
                                      touched={touched.no_machine}
                                      handleBlur={handleBlur}
                                      handleChange={handleChange}
                                      errorsField={errors.no_machine}
                                      value={values.no_machine}
                                    />
                                  )}
                                </Col>
                                <Col md="4">
                                  <InputText
                                    controlId="job_contact"
                                    label="Job Contact"
                                    placeholder="Job Contact"
                                    touched={touched.job_contact}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.job_contact}
                                    value={values.job_contact}
                                  />
                                </Col>
                                <Col md="4">
                                  <InputText
                                    disabled="disabled"
                                    controlId="company_name"
                                    label="Company"
                                    placeholder="Company"
                                    touched={touched.company_name}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.company_name}
                                    value={userData.company_name}
                                  />
                                  <p className="fs-15 ">
                                    If you are requesting an inspection on
                                    behalf of another company, please call (860)
                                    739-4446 or email us at{" "}
                                    <a href="mailto:info@hescocrane.co">
                                      info@hescocrane.com
                                    </a>
                                  </p>
                                </Col>
                                <Col md="4">
                                  <InputText
                                    controlId="po_no"
                                    label="PO No."
                                    placeholder="PO No."
                                    touched={touched.po_no}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.po_no}
                                    value={values.po_no}
                                  />
                                </Col>
                                <Col md="4">
                                  <InputText
                                    controlId="ordered_by"
                                    label="Ordered By"
                                    placeholder="Ordered By"
                                    touched={touched.ordered_by}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.ordered_by}
                                    value={values.ordered_by}
                                  />
                                </Col>

                                <Col md="4" className="date-time-cover1">
                                  <p className="fs-15 fw-semibold mb-0 text-default mt-3">
                                    Preferred Date & Time for inspection
                                  </p>
                                  {/*<InputDatePicker controlId="inspection_datetime" label='Date & Time' placeholder="Date & Time" touched={touched.inspection_datetime} handleBlur={handleBlur} handleChange={handleChange} errorsField={errors.inspection_datetime} value={values.inspection_datetime} />*/}
                                  {/*<DatePicker
                                                                      selected={new Date()}
                                                                      onChange={(date:any) => setFieldValue('inspection_datetime',date)}
                                                                      showTimeSelect
                                                                      value={values.inspection_datetime}
                                                                      name="inspection_datetime"
                                                                      timeFormat="HH:mm"
                                                                      timeIntervals={15}
                                                                      timeCaption="Time"
                                                                      dateFormat="MMMM d, yyyy h:mm aa"
                                                                      placeholderText="Date & Time"
                                                                    />*/}
                                  <MatDatePicker
                                    controlId="inspection_datetime"
                                    label="Date & Time"
                                    touched={touched.inspection_datetime}
                                    handleChange={(e: any) => {
                                      setFieldValue(
                                        "inspection_datetime",
                                        moment(e)
                                      );
                                    }}
                                    errorsField={errors.inspection_datetime}
                                    value={values.inspection_datetime}
                                    setValue={setInspectionDatetime}
                                  />
                                </Col>
                              </Row>
                            </div>
                            <div className="col-xl-12">
                              <Row>
                                <Col md="12" className="mb-4 ">
                                  <h2 className="fs-20 fw-bold ls-2 border-left-6 mb-2 text-uppercase">
                                    Machine Details
                                  </h2>
                                  <p className="fs-15 ">
                                    Select the existing machine from the below
                                    dropdown.{" "}
                                  </p>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="9" md="12">
                                  <Row>
                                    <Col sm="8" xs="9">
                                      {hideShowMachineDropdown && (
                                       <>
                                         {/* <InputSelectMultiple
                                          controlId="machine_inspect"
                                          label="Machine to inspect"
                                          placeholder="Machine to inspect"
                                          touched={touched.machine_inspect}
                                          handleBlur={handleBlur}
                                          handleChange={handleChange}
                                          errorsField={errors.machine_inspect}
                                          selected={selectMachines}
                                          setValue={setSelectMachines}
                                          options={machineList}
                                        />

                                      <pre>{JSON.stringify(selectMachines, null, 2)}</pre> */}
 
                                        <InputSelectMultipleAutocomplete
                                          controlId="machine_inspect"
                                          label="Machine to inspect"
                                          placeholder=""
                                          touched={touched.machine_inspect}
                                          handleBlur={handleBlur}
                                          handleChange={handleChange}
                                          errorsField={errors.machine_inspect}
                                          selected={selectMachines}
                                          setValue={setSelectMachines}
                                          options={machineList}
                                        />
                                        </>

                                        
                                      )}
                                    </Col>
                                    <Col sm="2" xs="3">
                                      <Button
                                        variant="warning"
                                        type="button"
                                        className="btn btn-warning fw-bold"
                                        onClick={() =>
                                          addSelectedMachine(
                                            values.machine_inspect,
                                            setFieldValue,
                                            values.no_machine
                                          )
                                        }
                                      >
                                        <img
                                          className="plus-icon"
                                          src={plusIcon}
                                        />
                                      </Button>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xl="3" md="12">
                                  <div className="text-xl-end mb-3">
                                    <p className="fs-13">
                                      Machine not found? Don't worry!
                                    </p>
                                    <a
                                      onClick={() => handleShow(setFieldValue)}
                                      className="text-link fs-15 fw-bold text-decoration-none cursor-pointer"
                                    >
                                      <i className="fas fa-plus-circle fs-13 me-1"></i>
                                      Add new machine
                                    </a>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="12" className="mb-3">
                                  <div className="table-responsive new-table-design">
                                    <table className="table custom-table border-none-table ">
                                      <thead>
                                        <tr>
                                          <th>Device ID</th>
                                          <th>Make</th>
                                          <th>Model no.</th>
                                          <th>Serial no.</th>
                                          <th>Inspection type</th>
                                          <th>Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {machineData.map(
                                          (data: any, index: any) => (
                                            <tr key={index}>
                                              <td>{data?.device_id}</td>
                                              <td>{data?.make}</td>
                                              <td>{data?.model_number}</td>
                                              <td>{data?.serial_number}</td>
                                              <td>
                                                {data?.inspection_type_show}
                                              </td>
                                              <td>
                                                <span
                                                  className="cursor-pointer"
                                                  onClick={() =>
                                                    deleteMachine(index)
                                                  }
                                                  title="Delete"
                                                >
                                                  <img src={DeleteIcon} />
                                                </span>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </Col>
                              </Row>
                            </div>

                            <div className="col-xl-12">
                              <Row>
                                <Col md="12">
                                  <h2 className="fs-20 fw-bold ls-2 border-left-6 mb-4 text-uppercase">
                                    Job Location
                                  </h2>
                                </Col>
                              </Row>
                              <Row>
                                {googleFields && (
                                  <Col md="4">
                                    <Col md="12">
                                      <InputText
                                        controlId="job_location_address"
                                        label="Address"
                                        placeholder="Address"
                                        touched={touched.job_location_address}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={
                                          errors.job_location_address
                                        }
                                        value={values.job_location_address}
                                      />
                                    </Col>
                                    <Col md="12">
                                      <InputText
                                        controlId="job_location_city"
                                        label="City"
                                        placeholder="City"
                                        touched={touched.job_location_city}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={errors.job_location_city}
                                        value={values.job_location_city}
                                      />
                                    </Col>
                                    <Row>
                                      <Col lg="6">
                                        <InputSelect
                                          controlId="job_location_state"
                                          label="State/Province"
                                          placeholder="State/Province"
                                          touched={touched.job_location_state}
                                          handleBlur={handleBlur}
                                          handleChange={handleChange}
                                          errorsField={
                                            errors.job_location_state
                                          }
                                          value={values.job_location_state}
                                          options={states}
                                        />
                                      </Col>
                                      <Col lg="6">
                                        <InputText
                                          controlId="job_location_zip_code"
                                          label="Zip"
                                          placeholder="Zip"
                                          touched={
                                            touched.job_location_zip_code
                                          }
                                          handleBlur={handleBlur}
                                          handleChange={handleChange}
                                          errorsField={
                                            errors.job_location_zip_code
                                          }
                                          value={values.job_location_zip_code}
                                        />
                                      </Col>
                                    </Row>
                                    <Col md="12">
                                      <InputTextArea
                                        controlId="job_location_comment"
                                        label="Comments (if any)"
                                        placeholder="Input additional information here i.e. multiple locations, site access instructions, etc."
                                        touched={touched.job_location_comment}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={
                                          errors.job_location_comment
                                        }
                                        value={values.job_location_comment}
                                        focused={true}
                                      />
                                    </Col>
                                  </Col>
                                )}
                                <Col md="8">
                                  <DraggableMarkerMap
                                    center={center}
                                    onReverse={handleReverse}
                                  />
                                  {/*<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14331.209636353391!2d74.3235535!3d26.105367949999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1678262700336!5m2!1sen!2sin" className='map-box'  loading="lazy" ></iframe>*/}
                                  <a
                                    href="Javascript:void(0)"
                                    className="btn btn-light border-radius-5 mt-3"
                                    onClick={() =>
                                      assignAddress(values, setFieldValue)
                                    }
                                  >
                                    <img
                                      className="pin-icon"
                                      src={GooglePinIcon}
                                    />
                                    Assign from Google Maps
                                  </a>
                                </Col>
                              </Row>
                            </div>

                            {/*Decal Information*/}
                          </Card.Body>
                        </Card>
                        <Card className="border-0 mb-3">
                          <Card.Body className="br-10 p-4">
                            <div className="col-xl-10 ">
                              <Row>
                                <Col md="12">
                                  <h2 className="fs-20 fw-bold ls-2 border-left-6 mb-4 text-uppercase">
                                    Decal Information
                                  </h2>
                                </Col>

                                <p className="fs-15 fw-semibold mb-3">
                                  Mail decals to the following address:
                                </p>
                                <Col md="4">
                                  <InputText
                                    disabled="disabled"
                                    controlId="decal_name"
                                    label="Name"
                                    placeholder="Name"
                                    touched={touched.decal_name}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_name}
                                    value={decalContact?.name}
                                    autofocus
                                  />
                                </Col>
                                <Col md="4">
                                  <InputText
                                    disabled="disabled"
                                    controlId="decal_email"
                                    label="Email"
                                    placeholder="Email"
                                    touched={touched.decal_email}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_email}
                                    value={decalContact?.email}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col md="4">
                                  <InputText
                                    disabled="disabled"
                                    controlId="decal_address"
                                    label="Address"
                                    placeholder="Address"
                                    touched={touched.decal_address}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_address}
                                    value={decalContact?.address}
                                  />
                                </Col>
                                <Col md="4">
                                  <InputText
                                    disabled="disabled"
                                    controlId="decal_city"
                                    label="City"
                                    placeholder="City"
                                    touched={touched.decal_city}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_city}
                                    value={decalContact?.city}
                                  />
                                </Col>
                                <Col md="2">
                                  <InputSelect
                                    disabled="disabled"
                                    controlId="decal_state"
                                    label="State/Province"
                                    placeholder="State/Province"
                                    touched={touched.job_location_state}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_state}
                                    value={decalContact?.state_id}
                                    options={states}
                                  />
                                </Col>
                                <Col md="2">
                                  <InputText
                                    disabled="disabled"
                                    controlId="decal_zip_code"
                                    label="Zip"
                                    placeholder="Zip"
                                    touched={touched.decal_zip_code}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.decal_zip_code}
                                    value={decalContact?.zip_code}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12" className="d-flex justify-content-end">
                        <Link
                          to="/app/sites/"
                          className="btn btn-light my-1 fw-semibold me-2"
                        >
                          Cancel
                        </Link>
                        <Button
                          type="submit"
                          variant="primary"
                          className="btn btn-primary my-1 fw-semibold"
                          disabled={disableSubmit}
                        >
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            ) : (
              ""
            )}
          </div>
        </div>

        {/*Add new machine*/}
        <Modal
          show={show}
          onHide={handleModalClose}
          centered
          dialogClassName="modal-350w"
        >
          <Modal.Header closeButton className="border-0 pb-0">
            <Modal.Title className="fs-25 fw-bold">New Machine</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              validationSchema={AddMachineSchema}
              initialValues={initialValuesMachine}
              onSubmit={(values, actions) => {
                actions.setSubmitting(false);
                addMachineSubmitForm(values, actions);
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                errors,
                touched,
                setFieldValue,
              }) => (
                <Form className="text-start" noValidate onSubmit={handleSubmit}>
                  <InputText
                    controlId="device_id"
                    label="Device ID"
                    placeholder="Device ID"
                    touched={touched.device_id}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    errorsField={errors.device_id}
                    value={values.device_id}
                  />
                  <InputText
                    controlId="make"
                    label="Make"
                    placeholder="Make"
                    touched={touched.make}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    errorsField={errors.make}
                    value={values.make}
                  />
                  <InputText
                    controlId="model_number"
                    label="Model no."
                    placeholder="Model no."
                    touched={touched.model_number}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    errorsField={errors.model_number}
                    value={values.model_number}
                  />
                  <InputText
                    controlId="serial_number"
                    label="Serial no."
                    placeholder="Serial no."
                    touched={touched.serial_number}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    errorsField={errors.serial_number}
                    value={values.serial_number}
                  />
                  <InputSelect
                    controlId="inspection_type"
                    label="Inspection Type"
                    placeholder="Inspection Type"
                    touched={touched.inspection_type}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    errorsField={errors.inspection_type}
                    value={values.inspection_type}
                    options={inspectionTypeOptions}
                  />

                  <div className="d-flex justify-content-end">
                    <Button
                      variant="outline-secondary"
                      className="me-2 fs-15 fw-semibold text-black"
                      onClick={handleModalClose}
                    >
                      Close
                    </Button>
                    <Button
                      variant="primary"
                      className="fs-15 fw-semibold text-black"
                      type="submit"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>

        <Loader isLoading={loading} />
      </Container>
    </section>
  );
};
